import type { DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import Driver from '/@/components/driverjs';
import { _ } from '/@/locale';
import { MY_FIELDS_TOUR_STORAGE_KEY } from '../consultant-fields-tour-ids';

type MyFieldsHelpTourDriverProps = {
    steps: DriveStep[];
    isLoading: boolean;
    onBeforeAutoStart?: () => void;
};

const MyFieldsHelpTourDriver = ({ steps, isLoading, onBeforeAutoStart }: MyFieldsHelpTourDriverProps) => {
    return (
        <Driver
            ONBOARDING_STORAGE_KEY={MY_FIELDS_TOUR_STORAGE_KEY}
            DRIVER_STEPS={steps}
            isLoading={isLoading}
            popoverTag={_('Mis Lotes')}
            onBeforeAutoStart={onBeforeAutoStart}
            mixpanelSection='my-fields'
            showHelpCenterLink
        />
    );
};

export default MyFieldsHelpTourDriver;
